<form [formGroup]="form" class="form addProduct">
  <app-dc-header class="header">
    <span class="heading">{{ pageTitle }} </span>
    <div class="actions">
      <button
        type="button"
        (click)="navigateBack()"
        class="btn btn-dark btn-sm mr-3"
      >
        Cancel</button
      ><button
        type="button"
        class="btn btn-primary btn-sm"
        (click)="saveProduct()"
        *ngIf="canUserEdit || this.id === 'new'"
        [disabled]="loading"
      >
        {{ path | saveButtonLabel }}
      </button>
    </div>
  </app-dc-header>

  <div class="sideBar">
    <app-dc-pane [loading]="loading" id="summary-form">
      <ng-container class="heading">
        Product Summary
        <img
          *ngIf="getSummaryFormGroup?.invalid"
          [title]="invalidFormMessage"
          src="assets/statusIncomplete.svg"
          class="invalid-fields-warning"
        />
      </ng-container>
      <ng-container *ngIf="!loading">
        <app-product-summary
          [formName]="formName"
          [productId]="prod?.id"
          [canUserEdit]="canUserEdit"
          [productTypeValue]="productTypeValue"
        ></app-product-summary>
      </ng-container>
    </app-dc-pane>
  </div>
  <div class="main">
    <app-dc-alert></app-dc-alert>
    <div class="sectionButtonContainer">
      <ng-container
        *ngFor="let button of sectionButtons | keyvalue: originalOrder"
      >
        <app-dc-section-button
          *ngIf="!button.value.hidden"
          (click)="changeMainSection(button.key)"
          [label]="button.value.label"
          [invalid]="getFormByKey(button.key)?.invalid"
          [invalidFormMessage]="
            getFormByKey(button.key)?.errorMessage || invalidFormMessage
          "
          [active]="mainSection === button.key"
        >
        </app-dc-section-button>
      </ng-container>
    </div>

    <app-dc-pane [loading]="loading" noHeader="true">
      <app-payoff
        [formName]="formName"
        formGroupName="payoff"
        [hidden]="mainSection !== 'payoff'"
        (dateRangeOut)="scheduleOutput($event)"
        [canUserEdit]="canUserEdit"
        [productId]="id"
        class="productDetailPane"
      ></app-payoff>
      <app-event-schedules
        *ngIf="!sectionButtons.get('eventSchedules')?.hidden && form"
        [productId]="id"
        [canUserEdit]="canUserEdit"
        [product]="prod"
        [productForm]="form"
        [isEditing]="isEditing()"
        [hidden]="loading || mainSection !== 'eventSchedules'"
      >
      </app-event-schedules>
      <app-credit-provision
        [formName]="formName"
        formGroupName="creditProvision"
        *ngIf="!loading"
        [hidden]="mainSection !== 'creditProvision'"
      ></app-credit-provision>
      <app-sales
        (emitAdd)="addSalesFeesRow()"
        (emitDelete)="deleteSalesFeesRow($event)"
        (emitAddTargetMarketRow)="addTargetMarketRow()"
        (emitDeleteTargetMarketRow)="deleteTargetMarketRow($event)"
        (emitAddContactInformationRow)="addContactInformationRow()"
        (emitDeleteContactInformationRow)="deleteContactInformationRow($event)"
        (dateRangeOut)="salesScheduleOutput($event)"
        formGroupName="sales"
        [hidden]="mainSection !== 'sales'"
        [canUserEdit]="canUserEdit"
      ></app-sales>
      <app-legal-form
        [formName]="formName"
        (emitAdd)="addLegalProductIdRow()"
        (emitDelete)="deleteLegalProductIdRow($event)"
        (emitCountryOfOfferAdd)="addCountriesOfOfferRow()"
        (emitCountryOfOfferDelete)="deleteCountriesOfOfferRow($event)"
        formGroupName="legalForm"
        [hidden]="mainSection !== 'legalForm'"
        [createOrEdit]="path"
        [productId]="id"
      ></app-legal-form>
      <app-agents
        [formName]="formName"
        (emitAdd)="addAgentRow()"
        (emitDelete)="deleteAgentRow($event)"
        formGroupName="agents"
        [hidden]="mainSection !== 'agents'"
      ></app-agents>
      <app-pricing
        [hidden]="mainSection !== 'pricing'"
        [productForm]="form">
      </app-pricing>
      <app-product-notes
        formGroupName="notesAndTasks"
        [formName]="formName"
        [hidden]="mainSection !== 'notesAndTasks'"
        [canUserEdit]="canUserEdit"
      ></app-product-notes>
    </app-dc-pane>
  </div>
</form>
